export interface ProjectPageSectionPlaylist {
    channelId: number;
}
